export default [
  {
    title: '首页',
    route: 'Dashboards',
    icon: 'HomeIcon',
    tagVariant:"danger"
  },
  {
    title: '走地大小球',
    route: 'zdDxq',
    icon: 'BarChart2Icon',
    tagVariant:"danger"
  },
  {
    title: '走地让球',
    route: 'zdRq',
    icon: 'CloudIcon',
  },
  {
    title: '走地角球',
    route: 'zdJq',
    icon: 'FlagIcon',
  },
  {
    title: '初盘大小球预测',
    route: 'cpDxq',
    icon: 'TrendingUpIcon',
  },
  {
    title: '初盘让球预测',
    route: 'cpRq',
    icon: 'DatabaseIcon',
  },
  {
    title: '初盘角球预测',
    route: 'cpJq',
    icon: 'MapPinIcon',
  },
]
